import Vue from 'vue';
import VueResource from 'vue-resource';
import converterMoeda from '~js/converter-moeda';
import formatarData from '~js/formatar-data';

Vue.use(VueResource);

export default {
  lista: () => {
    return Vue.http.get('/api/tipospassagem').then(response => response.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/tipo-passagem/servico.js